import { render, staticRenderFns } from "./teams.add.to.users.vue?vue&type=template&id=6c859274&scoped=true&"
import script from "./teams.add.to.users.vue?vue&type=script&lang=js&"
export * from "./teams.add.to.users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c859274",
  null
  
)

export default component.exports